import { defineStore } from 'pinia'
import { shallowRef, triggerRef } from 'vue'

export const useAnnotationErrorsStore = defineStore('annotationErrors', () => {
  const annotationsWithErrors = shallowRef<Map<string, { message: string; fatal: boolean }>>(
    new Map(),
  )
  const markAnnotationWithError = ({
    id,
    message,
    fatal = false,
  }: {
    id: string
    message: string
    fatal?: boolean
  }): void => {
    annotationsWithErrors.value.set(id, { message, fatal })
    triggerRef(annotationsWithErrors)
  }

  const clearAnnotationWithError = (id: string): void => {
    annotationsWithErrors.value.delete(id)
    triggerRef(annotationsWithErrors)
  }

  const clearAll = (): void => {
    annotationsWithErrors.value.clear()
    triggerRef(annotationsWithErrors)
  }

  return {
    annotationsWithErrors,
    markAnnotationWithError,
    clearAnnotationWithError,
    clearAll,
  }
})
